import React from "react";
const PrivacyPolicy = () => {
  return (
    <div className="container-xs">
      <h1>Privacy Policy</h1>
      <p>
        <strong>Last updated: 21 September 2026</strong>
      </p>
      <p>
        This Privacy Policy explains how the mobile application{" "}
        <strong>"What's for Tea"</strong> (the "App"), provided by dritec (the
        "we", "us" or "our"), handles your information. We are committed to
        protecting your privacy. This policy applies to the App available on the
        Google Play Store.
      </p>

      <h2>The short version</h2>
      <p>
        "What's for Tea" does <strong>not collect, store, or share any
        personal data</strong>. The App works entirely on your device. We have
        no servers that receive your information, we use no third-party
        analytics or advertising services, and we have no access to anything you
        do within the App.
      </p>

      <h2>Information we collect</h2>
      <p>
        <strong>We do not collect any personal information.</strong> We do not
        ask you to create an account, and we do not request your name, email
        address, location, contacts, or any other personal identifiers.
      </p>

      <h2>Information you create in the App</h2>
      <p>
        Any content you add to the App — such as meals, recipes, or planning
        information — is stored <strong>locally on your device only</strong>. It
        is never transmitted to us or to any third party. If you uninstall the
        App or clear its data, this information is removed from your device and
        cannot be recovered by us because we never held a copy of it.
      </p>

      <h2>Third-party services</h2>
      <p>
        The App does <strong>not</strong> use any third-party services, software
        development kits (SDKs), analytics tools, advertising networks, or cloud
        backends. Nothing you do in the App is sent to an external service.
      </p>

      <h2>Permissions</h2>
      <p>
        The App requests only the minimum permissions required for its features
        to function on your device. Any data accessed through such permissions
        stays on your device and is not collected or shared by us.
      </p>

      <h2>Data sharing and selling</h2>
      <p>
        Because we do not collect any personal data, we have no data to share,
        sell, or disclose to anyone, including advertisers, data brokers, or law
        enforcement.
      </p>

      <h2>Children's privacy</h2>
      <p>
        The App does not collect personal information from anyone, including
        children under the age of 13 (or the equivalent minimum age in your
        jurisdiction).
      </p>

      <h2>Data security</h2>
      <p>
        As all information stays on your own device, its security is governed by
        your device's own protections (such as your screen lock and operating
        system security features). We recommend keeping your device software up
        to date.
      </p>

      <h2>Changes to this policy</h2>
      <p>
        We may update this Privacy Policy from time to time, for example if a
        future version of the App introduces new features. Any changes will be
        posted on this page with an updated "Last updated" date. We encourage
        you to review this page periodically.
      </p>

      <h2>Contact us</h2>
      <p>
        If you have any questions about this Privacy Policy or the App, please
        contact us:
      </p>
      <h3>Email</h3>
      <a href="mailto:info@dritec.co.uk">info@dritec.co.uk</a>
    </div>
  );
};

export default PrivacyPolicy;
